import {ModuleController} from "../../infrastructure/controllers/module-controller";
import {BaseManagedService} from "../../infrastructure/domain-services/base-managed-service";
import {CompetitionsSliderWidgetConfig} from "./competitions-slider-widget.config";
import {CompetitionsSliderWidgetStore} from "./competitions-slider-widget.store";
import {CompetitionsSliderWidgetHandlers} from "./handlers/competitions-slider-widget.handlers";
import {CompetitionsDomainService} from "../../domain/competitions/services/competitions.domain-service";
import {CompetitionsSliderWidgetState} from "./models/competitions-slider-widget.state";

export class CompetitionsSliderWidgetController extends ModuleController {
  state: CompetitionsSliderWidgetState;

  static injectables = [...BaseManagedService.injectables, CompetitionsSliderWidgetConfig, CompetitionsSliderWidgetStore, CompetitionsSliderWidgetHandlers, CompetitionsDomainService];

}
